// SPDX-License-Identifier: MIT
// Copyright contributors to the openassistant project

import './index.css';

export { AiAssistant } from './components/assistant';
export { ScreenshotWrapper } from './components/screenshot-wrapper';
export { ConfigPanel } from './components/config-panel';
export type { AiAssistantConfig } from './components/config-panel';
